import last from 'lodash/last';
import BotStore from '@src/store';
import React from 'react';
import CommonStore from '@src/stores/CommonStore';

import { ROUTES } from '@src/const';

// Relements
import Notification from 'relements/build/esm/overlays/notification';

export function slugify(text) {
  return text
    .toLowerCase()
    .replace(/[^\w ]+/g, '')
    .replace(/ +/g, '-');
}

export function cleanArray(someArray) {
  return Array.isArray(someArray)
    ? someArray.filter((data) => data && data.length != 0)
    : someArray;
}

export function checkIfNumber(numberString) {
  return (
    Array.isArray(numberString) &&
    numberString - parseFloat(numberString) + 1 >= 0
  );
}

export function checkIfObject(value) {
  return (
    value != null &&
    typeof value === 'object' &&
    Object.prototype.toString.call(value) === '[object Object]'
  );
}

export function toTitleCase(str) {
  return str.replace(/\w\S*/g, (txt) => {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export function truncate(str, len) {
  return ((str && str.length) || 0) > len
    ? `${str.substring(0, len - 3)}...`
    : str;
}

export function initiateBootstrapToolTip() {
  // $(() => {
  //   $('[data-toggle="tooltip"]').tooltip();
  // });
}

export function textWithToolTipHtml(title, className, len) {
  if (((title && title.length) || 0) >= len) {
    return (
      <span
        className={className}
        data-original-title={title}
        data-toggle="tooltip"
        data-placement="bottom"
      >
        {truncate(title, len) || ''}
      </span>
    );
  }
  return <span className={className}>{truncate(title, len) || ''} </span>;
}

// Set object values to empty ones
export function emptyObject(someObject) {
  Object.keys(someObject).map((key) => {
    let value = someObject[key];

    if (key == 'id') {
      // Do nothing
    } else if (Array.isArray(value)) {
      someObject[key] = [];
    } else if (checkIfObject(value)) {
      someObject[key] = {};
    } else if (typeof value === 'boolean') {
      someObject[key] = false;
    } else if (checkIfNumber(value)) {
      value = Math.floor(Math.random() * 30000);
    } else {
      someObject[key] = '';
    }

    return key;
  });
}

export function convertBotData(botName, client, testBusiness) {
  return {
    title: botName.toLowerCase(),
    client,
    test_business: testBusiness || null,
  };
}

export function convertStoryData(storyName, domainId, domainTitle) {
  return {
    title: storyName,
    subtitle: '',
    domain_id: domainId,
    domain_title: domainTitle,
    subStoryList: [],
    author: '',
    id: Math.floor(Math.random() * 30000),
    modified_at: new Date().toLocaleDateString(),
    created_at: new Date().toLocaleDateString(),
    active: true,
  };
}

export function convertSubstoryList(
  allSubStories,
  storyId,
  domainId,
  domainTitle
) {
  const substoryList = allSubStories.reduce((result, _story) => {
    if (_story.title.trim().length !== 0) {
      result.push({
        id: _story.id,
        title: _story.title,
        active: _story.active,
      });
    }
    return result;
  }, []);

  const list = [];

  // TODO : clean instance of for-in loop
  // eslint-disable-next-line no-restricted-syntax
  for (const id in substoryList) {
    list.push(
      convertSubstoryData(
        substoryList[id].id,
        substoryList[id].title,
        substoryList[id].active
      )
    );
  }

  return {
    subStories: list,
    story_id: storyId,
    domain_id: domainId,
    domain_title: domainTitle,
  };
}

export function convertSubstoryData(id, subStoryName, active) {
  return {
    title: subStoryName,
    subtitle: '',
    id: id || Math.floor(Math.random() * 30000),
    modified_at: new Date().toLocaleDateString(),
    created_at: new Date().toLocaleDateString(),
    active,
  };
}

export function convertStepData(
  id,
  stepName,
  stepType,
  stepAttr,
  stepStatus,
  systemName,
  modelName,
  taskId,
  subStoryId,
  domainName,
  x,
  y
) {
  return {
    id: id || Math.floor(30000 * Math.random()),
    modified_at: new Date().toLocaleDateString(),
    created_at: new Date().toLocaleDateString(),
    title: stepName,
    step_status: stepStatus,
    step_type: stepType, // [{value: "Start", selected: true}, {value: "Context Clear", selected: false}]
    step_attr: {
      permanent: stepAttr.toLowerCase() == 'permanent',
      temporary: stepAttr.toLowerCase() == 'temporary',
    },
    system_name: systemName,
    substory_id: subStoryId,
    model_title: modelName,
    faq_id: taskId,
    domain_name: domainName,
    user_response: '',
    info_gathering: '',
    api_response: '',
    x,
    y,
  };
}

export function convertStepPriorities(id, stepPriorities) {
  return {
    id,
    priority_list: stepPriorities.priority_list.map((_step) => {
      const copy = { ..._step };

      copy.prioritized_steps = copy.prioritized_steps.filter(
        (_pstep) => !!_pstep.title.trim()
      );

      if (copy.active) {
        copy.active =
          copy.prioritized_steps &&
          copy.prioritized_steps.length !== 0 &&
          !!copy.priority.title.trim();
      }

      return copy;
    }),
  };
}

export function convertGeneralResponses(
  generalResponses,
  editedGeneralResponses
) {
  const context = editedGeneralResponses.domainId;

  generalResponses = generalResponses.filter((_response) => {
    if (!_response || _response.inputResponse.trim().length == 0) {
      return false;
    }
    _response.id = Math.floor(Math.random() * 30000);
    return true;
  });

  const sendData = {
    id: context,
    responses: generalResponses,
  };

  return sendData;
}

export function convertUserResponses(
  stepId,
  editedUserResponses,
  allUserResponses,
  currentLanguage
) {
  const _copyResponses = { ...editedUserResponses };
  _copyResponses.context = null;
  const data = {
    lang_src: currentLanguage.languageSource || 'en',
    lang_script: currentLanguage.languageScript || 'en',
  };

  // Todo: add proper error handling if certain records are wrong .
  // TODO : clean instance of for-in loop
  // eslint-disable-next-line no-restricted-syntax
  for (const responseType in editedUserResponses) {
    if (editedUserResponses.hasOwnProperty(responseType)) {
      if (responseType === 'negative') {
        const domainId = last(editedUserResponses[responseType]).domain_id;
        data.negative = editedUserResponses[responseType].reduce(
          (result, response) => {
            const copy = { ...response };
            copy.node_id = stepId;
            copy.connecting_node = responseType;
            copy.domain_id = domainId;

            if (typeof copy.id === 'string') {
              if (copy.title.trim().length === 0) {
                copy.active = false;
              }
              result.push(copy);
            } else if (copy.active && copy.title.trim().length > 0) {
              result.push(copy);
            }
            return result;
          },
          []
        );
      } else {
        const domainId = last(editedUserResponses[responseType]).domain_id;
        data[responseType] = editedUserResponses[responseType].reduce(
          (result, response) => {
            const copy = { ...response };
            copy.node_id = stepId;
            copy.connecting_node =
              responseType === 'independent' ? null : responseType;
            copy.domain_id = domainId;

            if (typeof copy.id === 'string') {
              if (copy.title.trim().length === 0) {
                copy.active = false;
              }
              result.push(copy);
            } else if (copy.active && copy.title.trim().length > 0) {
              result.push(copy);
            }
            return result;
          },
          []
        );
      }
    }
  }

  return data;
}

// ------ Overlays state update handlers ---------------------------------

// Updates state of overlays
// and adds edited states to an editedValues object
export function updateState(data, setSource, editedValues, context, args) {
  if (
    context == 'step-priorities' &&
    (data.type == 'update' || data.type == 'inline-select')
  ) {
    return updateStepPriorities(data, setSource, editedValues, args);
  }
  if (args && args.delete) {
    return removeValueFromSource(data, setSource, editedValues, context);
  }

  let original;
  if (args) {
    original = args.original;
  }

  return addValueToSource(data, setSource, editedValues, context, original);
}

// Add or modify a value in an array of objects
// Each object should have an input type corresponding
// to each editable key in it. In the getConfig() function
// the default value to be concatenated and mapping between
// input type and key name of each object can be set
function addValueToSource(data, setSource, editedValues, context, original) {
  const { type } = data;
  const temp = data.id.split('-');
  const { map } = data;
  let { value } = data;
  let id = temp[temp.length - 1];

  const config = getConfig(context, id);

  /* Set configuration:
        *
        * TYPES: maps input types with fields
        * DEFAULT: default object
        * CHECK_INDEX: check if index should be matched
                                        otherwise, check the id
        * WIPE_WHEN_ADD: clear all values of previous state
                                            when adding a new object with same
                                            ID
        * PRIMARY_TYPE: primary key to store in edited values
        * PRESERVE_VALUE: if value is preserved in backend, set
                                            an active flag instead of wiping the
                                            value in editedValues
        * ADD_TO_FRONT: Concatenate to the front of the source
                                        array instead of it's end
                                        */

  const TYPES = config.type;
  const DEFAULT = config.default;
  const CHECK_INDEX = config.checkIndex;
  const WIPE_WHEN_ADD = config.wipeWhenAdd;
  const PRIMARY_TYPE = config.primaryType;
  const PRESERVE_VALUE = config.preserveValue;
  const ADD_TO_FRONT = config.addToFront;

  let setValue = false;
  let getUpdate = data.update || false;

  if (data) {
    setSource = setSource.map((_data, index) => {
      if ((!CHECK_INDEX && _data.id == id) || (CHECK_INDEX && index == id)) {
        // Object is found, setValue is true
        setValue = true;

        // Make a copy of the data
        let copyData = { ..._data };

        // Redundant update, break the loop
        if (_data[TYPES[type]] == data.value) {
          return _data;
        }

        // Clean the passed values of null/falsey values
        if (Array.isArray(value)) {
          value = cleanArray(value);
        }

        // If the new data has to wiped and the primary
        // type of the row is changed
        // Relevant when ID is an index and thus values
        // need to be wiped for a particular ID when
        // the primary value is changed
        // See Information Gathering Overlay for an example
        if (WIPE_WHEN_ADD && type == PRIMARY_TYPE) {
          editedValues[_data[TYPES[type]]] = _data;

          // If the value if preserved in the backend, set
          // active flag to false for the previous value
          // and store it in editedValues
          if (PRESERVE_VALUE) {
            editedValues[_data[TYPES[type]]].active = false;
          }

          // Wipe the data
          emptyObject(copyData);
          copyData[TYPES[type]] = value;
          editedValues[data.value] = copyData;

          if (PRESERVE_VALUE) {
            editedValues[data.value].active = true;
          }

          // Force an change to be emitted, to wipe values
          // in the UI
          getUpdate = true;
        } else {
          // Don't wipe the data and simply set the current
          // value using the TYPES map, or set the original value
          // if passed (for when a value has been removed and added)
          if (!original) {
            copyData[TYPES[type]] = value;
          } else {
            copyData = original;
          }
          // If a primary type exists, save that as the key in editedValues
          if (PRIMARY_TYPE) {
            if (type != PRIMARY_TYPE) {
              editedValues[_data[TYPES[PRIMARY_TYPE]]] = copyData;
              // Need to set the active false in case this is the first
              // update
              if (PRESERVE_VALUE) {
                editedValues[_data[TYPES[PRIMARY_TYPE]]].active = true;
              }
            } else {
              editedValues[data.value] = copyData;
              if (PRESERVE_VALUE) {
                editedValues[data.value].active = true;
              }
            }
          }
          // If a map for input exists, set the required values
          else if (map) {
            const keys = Object.keys(map);
            // TODO: clear isntances of for-in loop
            // eslint-disable-next-line no-restricted-syntax
            for (const key in map) {
              copyData[key] = map[key][value];
              if (key == 'id') {
                id = map[key][value];
              }
            }
            editedValues[id] = copyData;
          }
          // Otherwise set by ID received
          else {
            editedValues[id] = copyData;
          }
        }
        return copyData;
      }
      return _data;
    });

    // If an exisiting ID does not match with
    // updated ID, concatenate a new default
    // value to the source and add to edited values
    if (!setValue) {
      if (CHECK_INDEX && id >= setSource.length) {
        const copyDefault = { ...DEFAULT };
        for (let i = setSource.length; i < id; i++) setSource.push(copyDefault);
      }

      if (undefined !== DEFAULT[TYPES[type]] && DEFAULT[TYPES[type]] !== null) {
        DEFAULT[TYPES[type]] = value;
      }

      if (!ADD_TO_FRONT) {
        setSource = setSource.concat([DEFAULT]);
      } else {
        setSource = [DEFAULT].concat(setSource);
      }

      if (DEFAULT[TYPES.text]) {
        editedValues[id] = DEFAULT;
      }
    }
  }

  return {
    data: setSource,
    edited: editedValues,
    getUpdate,
  };
}

// Remove a value from source set
function removeValueFromSource(data, setSource, editedValues, context) {
  const temp = data.id.split('-');
  const id = temp[temp.length - 1];
  const config = getConfig(context, id);
  const CHECK_INDEX = config.checkIndex;
  const PRESERVE_VALUE = config.preserveValue;
  const DONT_CLEAR_ON_DELETE = config.dontClearOnDelete;
  const TYPES = config.type;
  const PRIMARY_TYPE = config.primaryType;
  const PRESERVE_VALUE_IN_SOURCE = config.preserveInSource;

  if (PRESERVE_VALUE_IN_SOURCE) {
    setSource = setSource.map((_data, index) => {
      if ((!CHECK_INDEX && _data.id == id) || (CHECK_INDEX && index == id)) {
        _data.active = false;
        editedValues[id] = _data;
      }

      return _data;
    });
  } else {
    setSource = setSource.filter((_data, index) => {
      if ((!CHECK_INDEX && _data.id == id) || (CHECK_INDEX && index == id)) {
        if (!PRESERVE_VALUE) {
          if (!DONT_CLEAR_ON_DELETE) {
            emptyObject(_data);
          }

          editedValues[id] = _data;
        } else {
          _data.active = false;
          editedValues[_data[TYPES[PRIMARY_TYPE]]] = _data;
        }
        return false;
      }
      return true;
    });
  }

  return {
    data: setSource,
    edited: editedValues,
  };
}

// Add, update or delete a priority
function updateStepPriorities(data, setSource, editedValues, args) {
  // Add new node priority
  let update = false;
  if (args) {
    const newValue = {
      id: Math.floor(Math.random() * 30000),
      title: '',
    };

    if (args.add) {
      setSource = setSource.map((item) => {
        if (item.id == data.id) {
          item.prioritized_steps = item.prioritized_steps.concat([newValue]);
        }
        return item;
      });

      return {
        data: setSource,
        edited: editedValues,
      };
    }

    // Remove node priority

    const idString = data.id.split('-');
    const itemId = idString[0];
    const stepId = idString[1];

    setSource = setSource.map((item) => {
      if (item.id == itemId) {
        item.prioritized_steps = item.prioritized_steps.filter(
          (step) => step.id != stepId
        );

        if (!editedValues[item.id]) {
          editedValues[item.id] = item;
        } else {
          editedValues[item.id].prioritized_steps = item.prioritized_steps;
        }
      }
      return item;
    });

    return {
      data: setSource,
      edited: {},
    };
  }

  // Modify existing selected node

  const idString = data.id.split('-');
  const priority = idString[0] == 'priority';
  const itemId = idString[1];
  const stepId = idString[2];
  let sourceValue;
  setSource = setSource.map((item) => {
    if (item.id == itemId) {
      if (item.prioritized_steps && item.prioritized_steps.length > 0) {
        item.prioritized_steps.map((step, index) => {
          if (step.id == stepId) {
            step.title = data.value;
            sourceValue = step;

            if (!editedValues[itemId]) {
              editedValues[itemId] = item;
            }

            editedValues[itemId].prioritized_steps = editedValues[
              itemId
            ].prioritized_steps.map((editedStep) => {
              if (editedStep.id == stepId) {
                editedStep.title = data.map.title[data.value];
                editedStep.id = data.map.id[data.value];

                if (priority) {
                  item.priority.id = editedStep.id;
                  item.priority.title = editedStep.title;
                }
                update = true;
              }
              return editedStep;
            });
          }
          return step;
        });
      } else {
        item.prioritized_steps = [];
        const added = {
          id: data.map.id[data.value],
          title: data.map.title[data.value],
        };
        if (priority) {
          item.priority.id = data.map.id[data.value];
          item.priority.title = data.map.title[data.value];
        }
        item.prioritized_steps.push(added);
        update = true;
      }
    }
    return item;
  });

  return {
    data: setSource,
    edited: editedValues,
    update,
  };
}

// Function to get config for a context
// Used in function addValueToSource()
function getConfig(context, id) {
  const data = {
    type: {},
    default: {},
    checkIndex: false,
    preserveValue: false,
    wipeWhenAdd: false,
    dontClearOnDelete: false,
    primaryType: null,
    preserveInSource: false,
    addToFront: false,
  };

  switch (context) {
    case 'step-priorities':
      {
        data.type = {
          text: 'desc',
        };
        const _id = Math.floor(Math.random() * 30000);
        data.default = {
          active: true,
          desc: '',
          id: id || Math.floor(Math.random() * 10000),
          prioritized_steps: [
            {
              title: '',
              id: _id,
            },
          ],
          priority: {
            title: '',
            id: _id,
          },
        };

        data.preserveInSource = true;
        data.preserveValue = true;
        data.addToFront = true;
      }
      break;

    case 'general-responses':
      data.type = {
        text: 'inputResponse',
        checkbox: 'stopFlag',
        mult: 'outputResponse',
      };

      data.default = {
        id,
        stopFlag: false,
        outputResponse: [],
        inputResponse: '',
      };

      data.checkIndex = true;
      break;

    default:
      break;
  }
  return data;
}

export function convertClusters(domainName, clusters) {
  return { domain_name: domainName, synonym_clusters: { ...clusters } };
}

export function convertEntities(nodeName, entities) {
  const convertedEntities = {
    node_name: nodeName,
  };

  let nodeEntities = { ...entities };
  Object.keys(nodeEntities).map((cluster) => {
    const { entity, words, ...rest } = nodeEntities[cluster];
    nodeEntities = { ...nodeEntities, [cluster]: { ...rest } };
  });

  convertedEntities.node_entities = nodeEntities;
  return convertedEntities;
}

export function createFileAndDownload(data, filename) {
  const link = document.createElement('a');
  link.setAttribute('download', filename);

  const blobData = new Blob([data], { type: 'text/plain' });
  const url = window.URL.createObjectURL(blobData);
  link.href = url;

  document.body.appendChild(link);

  // wait for the link to be added to the document
  window.requestAnimationFrame(() => {
    const event = new MouseEvent('click');
    link.dispatchEvent(event);
    document.body.removeChild(link);

    setTimeout(() => {
      // Need to revoke the URL to avoid memory leaks
      window.URL.revokeObjectURL(url);
    }, 1000);
  });
}

/**
 * Takes a URL and appends a query parameter to it.
 * It takes into account existing hash, and other query params
 *
 * Example
 * ----------
 * Input =>
 *      key: 'test'
 *      value: true
 *      url: http://google.com/abs/a?awesome=great
 *
 * Output =>
 *      http://google.com/abs/a?awesome=great&test=true
 *
 * updateQueryString('key1', 'value1', '#/a/b/c')
 * "#/a/b/c?key1=value1"
 *
 * updateQueryString('key1', 'value1', '#/a/b/c?key2=1')
 * "#/a/b/c?key2=1&key1=value1"
 *
 * updateQueryString('key1', 'value1', '#/a/b/c?key1=1')
 * "#/a/b/c?key1=value1"
 *
 * @param {string} key: Key to set
 * @param {string} value: Value for the key
 * @param {string} url: The URL to append the query string to
 */
export function updateQueryString(key, value, url) {
  if (!url) url = window.location.href;
  const re = new RegExp(`([?&])${key}=.*?(&|#|$)(.*)`, 'gi');

  if (re.test(url)) {
    if (typeof value !== 'undefined' && value !== null) {
      return url.replace(re, `$1${key}=${value}$2$3`);
    }
  }

  if (typeof value !== 'undefined' && value !== null) {
    const separator = url.indexOf('?') !== -1 ? '&' : '?';
    url = `${url + separator + key}=${value}`;
    return url;
  }
  return url;
}

export function triggerDownload(filename, url) {
  const link = document.createElement('a');
  link.download = filename;
  link.href = url;
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function isProduction() {
  // return true;
  return BotStore.getEnvironment() === 'production';
}

export const handleEmptyIVAList = () => {
  // If env is not production then redirect the user to create bot page.
  const url = `${window.location.origin}${ROUTES.CREATE_NEW_IVA}`;
  window.location.href = url;
};

/**
 * Adds hyphen support to language codes which contain hyphen
 * If a language code contains hyphen, then return the code as it is, else convert it.
 * NOTE: To be used within callback of humps.camelize or humps.decamelize
 * @param key key key which is to be converted
 * @param convert convert function which converts the key to camel case / decamel case
 */
export const langaugeCodeKeyDecamelize = (key, convert) => {
  const supportedLanguages = CommonStore.getMetaTags()?.domain?.language_list;

  if (key.includes('-') && supportedLanguages.includes(key)) {
    return key;
  }
  return convert(key);
};

/**
 * This function will copy the text sent as parameter to clipboard.
 * @param {String} copyText
 * @param {String} text
 */
export const copyToClipboard = (copyText, text) => {
  navigator.clipboard.writeText(copyText).then(
    () => {
      Notification.send({
        title: 'Copied!',
        message: `${text} has been copied to the clipboard.`,
        type: 'success',
      });
    },
    (err) => {
      Notification.send({
        title: 'Failed to copy!',
        message: err,
        type: 'error',
      });
    }
  );
};
